import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGIN_CREDENTIALS, ROUTES } from "../config";

const isValidLogin = (username: string, password: string) => {
  return LOGIN_CREDENTIALS[username] === password;
};

const SecureLogin = () => {
  const [errorMessage, setErrorMessage] = useState<string>();
  const navigate = useNavigate();

  const hashAndSaltAndCheckValidity = (event: any) => {
    event.preventDefault();
    const username = event.target["username"].value;
    const password = event.target["password"].value;
    const trimmedUsername = username.toLowerCase().trim().replace(" ", "");
    const validLogin = isValidLogin(trimmedUsername, password);
    if (validLogin) {
      window.localStorage.setItem("username", trimmedUsername);
      navigate(ROUTES.home);
    } else {
      setErrorMessage("Fittetryne, bruk riktig credentials");
    }
  };

  return (
    <div className="login-screen">
      <h1>login ofc</h1>
      <form onSubmit={hashAndSaltAndCheckValidity}>
        <input
          type="text"
          name="username"
          className="sign-in-input"
          placeholder="username"
        />
        <input
          type="text"
          name="password"
          className="sign-in-input"
          placeholder="password"
        />
        <button type="submit" className="sign-in-button">
          Log in
        </button>
      </form>
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </div>
  );
};

export default SecureLogin;
